import { connect } from 'react-redux';
import ExecutionEnvironment from 'exenv';

import { setResponseStatus } from 'actions/client';
import ErrorPage from 'components/error/ErrorPage';

export const makeError = params => {
  let routeInfo = '';

  if (params && params.splat) {
    routeInfo = `: ${params.splat}`;
  }

  return ({
    statusCode: 404,
    type: ExecutionEnvironment.canUseDOM ? 'CLIENT' : 'SERVER',
    event: { detailedMessage: `Route Not Found${routeInfo}` }
  });
};

const RouteNotFound = ({ params }) => <ErrorPage error={makeError(params)} />;
RouteNotFound.fetchDataOnServer = store => Promise.resolve(store.dispatch(setResponseStatus(404)));

export default connect()(RouteNotFound);
